import React from "react"
import { useHistory } from "react-router-dom"
import { useTranslation } from "react-i18next"
function CardNews({ news }) {
  const history = useHistory()
  const { t } = useTranslation()
  const handleReadMore = () => {
    history.push(`/read/${news._id}`)
  }

  return (
    <div className="uk-card uk-card-default uk-border-rounded uk-overflow-hidden">
      <div className="uk-cover-container uk-card-media-top uk-width-1-1 uk-height-medium">
        <img
          src={news.image}
          alt="GEMAS activities"
          className="uk-margin-remove-top"
          uk-cover="true"
        />
      </div>
      <div className="uk-card-body">
        <h3 className="uk-card-title uk-text-left font-red">{news.title}</h3>
        <div className="uk-text-secondary uk-text-small uk-text-left uk-margin-small-bottom">
          <span>{news.excerpt} ...</span>
        </div>
        <button
          onClick={handleReadMore}
          className="uk-button uk-button-default uk-text-capitalize uk-border-rounded font-white bg-red"
        >
          {t("home.cardbutton")}
        </button>
      </div>
    </div>
  )
}

export default CardNews
